var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSolarIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 30,
    viewBox: "0 0 52 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "premiumIcon",
    fill: "currentColor",
    d: "M9.243.417h34.664l7.546 21.666H.412z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "square",
    strokeWidth: 0.5,
    d: "M5.565 11.77h41.47M7.857 5.73h37.058M21.35 1.195l-2.87 20.09M32.6.987l3.177 20.936"
  }), /*#__PURE__*/React.createElement("path", {
    className: "premiumIcon",
    fill: "currentColor",
    d: "M28.328 26.875h6.667V30H18.12v-3.125h6.667v-4.792h3.541v4.792z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSolarIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/solar-icon.dc0b4a23ea9398219ece09cfba5f821f.svg";